<template>
  <FormBlock>
    <FormHeading :h="4">{{ $tt('emergency_contact') }}</FormHeading>
    <AppRow>
      <TextField
        v-model="contact.name"
        :label="$tt('emergency_contact_full_name')"
        :rules="[required]"
      />
      <PhoneField v-model="contact.phone" :label="$tt('emergency_contact_phone')" :rules="[required]" />
    </AppRow>
    <AppRow v-if="hasRelation">
      <TextField v-model="contact.relation" :label="$tt('emergency_contact_relation')" :rules="[required]" />
    </AppRow>
    <AddressFields v-if="hasAddress" v-model="contact.address!" :label="$tt('emergency_contact_address')" />
  </FormBlock>
</template>

<script setup lang="ts">
import type { EmergencyContact } from '~/types';

const contact = defineModel<EmergencyContact>({ required: true });
defineProps<{
  hasAddress?: boolean;
  hasRelation?: boolean;
}>();

const { required } = useValidation();
</script>